import { useMutation } from "@apollo/client";
import { EVENT_REPORT_PDF } from "graphql/mutation/event-gql";
import { successNotification, errorNotification } from "components/request-result";
import { saveAs } from "file-saver";


const useMutationEventReportPdf = () => {

    function getFileNameFromUrl(url) {
        const value = url.split('/');
        return value[ value.length - 1 ];
    }

    const [ _setEventReportPdf, { loading } ] = useMutation(EVENT_REPORT_PDF,
        {
            update(cache, { data }) {

                const {
                    eeReportPdf: {
                        label,
                        message,
                        file
                    }
                } = data;

                successNotification({
                    title: label,
                    description: message
                })


                saveAs(file, getFileNameFromUrl(file));
            },


            onError(error) {
                errorNotification(error);
            },

        }
    );


    return {
        _setEventReportPdf,
        loadingMutationEventReportPdf: loading,
    }
};


export default useMutationEventReportPdf;

